import { gql, useMutation } from '@apollo/client';

import { GET_QUESTIONNAIRES_SETTINGS } from './get-employee-questionnaire-settings.hook';
import { GET_QUESTIONNAIRES_SETTINGS_BY_ID } from './get-employee-questionnaire-settings-by-id.hook';
import { GET_ALL_QUESTIONNAIRES_SETTINGS } from './get-all-employee-questionnaire-settings.hook';
import { GET_QUESTIONNAIRES_SETTINGS_BY_IDS } from './get-employee-questionnaire-settings-by-ids.hook';

export const CREATE_QUESTIONNAIRES_SETTINGS = gql`
  mutation createEmployeeQuestionnaireSetting($payload: CreateEmployeeQuestionnaireSettingInput!) {
    createEmployeeQuestionnaireSetting(payload: $payload) {
      _id
      name
      settings
      companyId
      supervisorEmailTemplateId
      applicantEmailTemplateId
    }
  }
`;

export const useCreateEmployeeQuestionnaireSetting = ({ onSuccess }: { onSuccess: () => void }) => {
  const [createEmployeeQuestionnaireSetting] = useMutation(CREATE_QUESTIONNAIRES_SETTINGS, {
    onCompleted: onSuccess,
    refetchQueries: [
      GET_QUESTIONNAIRES_SETTINGS,
      GET_ALL_QUESTIONNAIRES_SETTINGS,
      GET_QUESTIONNAIRES_SETTINGS_BY_ID,
      GET_QUESTIONNAIRES_SETTINGS_BY_IDS,
    ],
  });
  return createEmployeeQuestionnaireSetting;
};
